import React from "react";
import PropTypes from "prop-types";


const LightboxImage = ({ image }) => {
	if (!image) return null;

	const {
		caption,
		url,
		alt
	} = image;

	if (!url) return null;

	// lightbox view
	return (
		<figure className={`lightbox-figure`}>
			<img className="lightbox-figure__image" src={url} alt={alt} />
			{caption && (
				<figcaption
					className="lightbox-figure__caption"
					dangerouslySetInnerHTML={{ __html: caption }}
				></figcaption>
			)}
		</figure>
	);
};


LightboxImage.propTypes = {
	image: PropTypes.shape({
		url: PropTypes.string.isRequired,
		caption: PropTypes.string,
		alt: PropTypes.string,
	}).isRequired,
};


export default LightboxImage;
